"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _utils = require("@whitbread-eos/utils");
var _nextI18next = require("next-i18next");
var _react2 = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SkeletonBox = _ref => {
  var {
    width = '50%',
    height = '20px',
    borderRadius = '4px'
  } = _ref;
  return (0, _jsxRuntime.jsx)(_react.Box, {
    "data-testid": "skeleton-box",
    width: width,
    height: height,
    borderRadius: borderRadius,
    bg: "#EEEEEE",
    position: "relative",
    overflow: "hidden",
    margin: '0 auto',
    _before: {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-100%',
      width: '100%',
      height: '100%',
      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)',
      animation: 'shimmer 1.8s infinite ease-in-out'
    },
    sx: {
      '@keyframes shimmer': {
        '0%': {
          left: '-100%'
        },
        '50%': {
          left: '100%'
        },
        '100%': {
          left: '100%'
        }
      }
    }
  });
};
var MonthTab = _ref2 => {
  var {
    language,
    label,
    price,
    isActive,
    currencySymbol,
    onClick,
    isLoading
  } = _ref2;
  var {
    container,
    badge,
    bottomHighlight,
    priceWrapper,
    labelText
  } = styles(isActive, label);
  var {
    t
  } = (0, _nextI18next.useTranslation)();
  var fromLowestPrice = (0, _utils.formatPrice)((0, _utils.formatCurrency)(currencySymbol), price, language);
  return (0, _jsxRuntime.jsxs)(_react.Flex, _objectSpread(_objectSpread({}, container), {}, {
    onClick: onClick,
    "data-testId": "month-tab-".concat(label),
    children: [(0, _jsxRuntime.jsx)(_react.Text, _objectSpread(_objectSpread({}, labelText), {}, {
      children: label
    })), isLoading && isActive ? (0, _jsxRuntime.jsx)(SkeletonBox, {}) : !!price && isActive && (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, priceWrapper), {}, {
        children: (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [(0, _jsxRuntime.jsx)(_react.Text, {
            as: "span",
            children: t('priceFinder.from')
          }), (0, _jsxRuntime.jsx)(_react.Text, _objectSpread(_objectSpread({}, badge), {}, {
            children: fromLowestPrice
          }))]
        })
      }))
    }), isActive && (0, _jsxRuntime.jsx)(_react.Box, _objectSpread({}, bottomHighlight))]
  }));
};
var _default = exports.default = MonthTab;
var styles = (isActive, label) => ({
  container: {
    as: 'button',
    direction: 'column',
    align: 'center',
    justify: 'center',
    width: '145px',
    height: isActive ? '72px' : '50px',
    flexShrink: 0,
    mx: 2,
    position: 'relative',
    bg: isActive ? 'white' : '#e9f2f3',
    color: isActive ? '#02798d' : 'gray.700',
    border: '1px solid #c4cacb',
    borderBottom: 'none',
    borderTopLeftRadius: 'md',
    borderTopRightRadius: 'md',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0',
    zIndex: isActive ? 1 : 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: 'md',
    dataMonthValue: label,
    _hover: isActive ? {
      bg: 'white',
      cursor: 'pointer',
      zIndex: 2
    } : {
      bg: 'white',
      color: '#02798d',
      cursor: 'pointer',
      height: '60px',
      transition: 'height 0.2s'
    }
  },
  labelText: {
    fontWeight: isActive ? 'bold' : 'medium'
  },
  priceWrapper: {
    mt: 1,
    fontSize: 'xs',
    color: 'var(--chakra-colors-darkGrey1)'
  },
  badge: {
    as: 'span',
    bg: '#fdb913',
    color: '#333333',
    px: 2,
    py: 0.5,
    ml: 1,
    fontWeight: '500',
    lineHeight: '20px',
    borderRadius: 'sm',
    display: 'inline-block',
    fontSize: '13px',
    padding: '0 2px',
    h: '19px'
  },
  bottomHighlight: {
    position: 'absolute',
    bottom: '-1px',
    left: 0,
    right: 0,
    height: '2px',
    bg: 'white',
    zIndex: -1,
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px'
  }
});